module.exports = __webpack_public_path__ + "static/media/SUEZ General Terms Of Use.0e3b0b5b.pdf";